import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgClientCard = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 264 123" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#C2C5CC" d="M51 54h49v1H51zM4 117h49v1H4zm0-31h49v1H4z" />
      <path
        d="M51 14 61 4m2 10L73 4m3 10L86 4m2 10L98 4m3 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m2 10 10-10M51 36l10-10m2 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m2 10 10-10m-58 97 10-10m2 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m3 10 10-10m40 10 10-10m-48 10 10-10m40 10 10-10m-47 10 10-10m40 10 10-10m-48 10 10-10m40 10 10-10M104 96l20-20m-7 20 20-20m-8 20 20-20m-7 20 20-20m-7 20 20-20m-8 20 20-20m18 20 20-20m5 20 20-20m-70 20 20-20m18 20 20-20m5 20 20-20m-71 20 20-20"
        stroke="#C2C5CC"
        fill="#C2C5CC"
        fillRule="nonzero"
      />
      <circle stroke="#C2C5CC" cx={20} cy={20} r={19.5} />
    </g>
  </svg>
);
const Memo = memo(SvgClientCard);
export default Memo;
